<!-- 1440 安全  -->
<template>
  <section class="header_view">
    <div class="header">
      <div class="headerBox">
        <div class="boxLeft">
          <ul>
            <li @click="openHomepage">
              <img :src="require('@/assets/image/icon/logo2.png')" alt="" />
            </li>
            <li
              v-for="(item, index) in nav"
              :key="index"
              :class="select == item.id ? 'select' : ''"
              @click="but(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="boxRight" v-if="false"><!--  style="filter: grayscale(1);" -->
          <span class="style_1" @click="aheftBut()">個人報名</span>
          <div style="width:20px;"></div>
          <span class="style_2" @click="toAdminRegister()">學校登入</span>

        </div>
        <div class="boxRight" v-if="false">
          <div class="upload-btns">
            <!-- <div class="upload_icon">
              <img :src="require('@/assets/image/icon/video_icon.png')" alt="" />
            </div> -->
            <div class="uploadVideo" style="filter: grayscale(1);" title="複賽結束">上載影片</div>
            <!-- <div class="uploadVideo" @click="handleUploadVideo()">上載影片</div> -->
            <!-- <div class="uploadVideo" @click="handleToAdmin()">學校</div> -->
          <div style="width:20px;"></div>
          <span class="style_2" @click="handleToAdmin()">學校登入</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { speecheduUrl } from "@/utils/link";
export default {
  name: "views",
  data() {
    return {
      nav: [
        {
          id: "0",
          name: "活動首頁",
          path: "/",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        // 	id:1,
        // 	name:'比賽指引',
        // 	path:'/',
        //   href:null,
        // },
        {
          id: "2",
          name: "比賽誦材",
          path: "/material",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        {
          id: "3",
          name: "比賽章程",
          path: "/rules",
          href:
            "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2024-04/e7bcc39b7ecd867074ab6a773fc3c0a0.pdf",
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        {
          id: "4",
          name: "成績公示",
          path: "/achievement",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        {
          id: "5",
          name: "決賽報道",
          path: "/eventReview_2026",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        {
          id: "6",
          name: "歷屆賽事回顧",
          path: "/eventReview",
          href: null,
          type: 1, //1是本地跳轉   2,pdf預覽   3,外鏈
        },
        // {
        //   id: "6",
        //   name: "比賽APP下載",
        //   path: "/",
        //   href: "https://app.chineserd.com",
        //   type: 3, //1是本地跳轉   2,pdf預覽   3,外鏈
        // },
      ],
    };
  },
  props: {
    select: {
      type: String,
      default: "0",
    },
  },
  computed: {},
  components: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleUploadVideo() {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '複賽已結束，感謝你的參與',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })
      // return
      // 监听当前的路由是不是首页，如果是首页，则跳转到上传视频页面，否则不跳转
      if (this.$route.path === '/') {
        this.$emit('viewUploadVideo')
      } else {
        this.$router.push({
          path: '/',
          query: {
            uploadVideo: true
          }
        })
      }
    },
    handleToAdmin() {
      // 跳管理后台上传视频
      let url = 'https://edu.chineserd.com/recitalCompetition/upload-finals-video'
      if (window.location.host.indexOf('chineserd') == -1) {
        url = 'https://edutest.chineserd.com/recitalCompetition/upload-finals-video'
      }
      window.open(url, '_blank')
    },

    getQueryString: function(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    toAdminRegister() {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '報名未開始',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })
      //   return
      // 跳学校管理后台
      let url = 'https://edu.chineserd.com/schoolInformation'
      if (window.location.host.indexOf('chineserd') == -1) {
        url = 'https://edutest.chineserd.com/schoolInformation'
      }
      window.open(url, '_blank')
    },
    aheftBut(e) {
      // TODO: 0513
      // this.$dialog
      //   .alert({
      //     title: "提示",
      //     message: "報名已結束",
      //     confirmButtonText: "確認",
      //   })
      //   .then(() => {
      //     // on close
      //   });
      // return;
      if (
        this.getQueryString("c") != null ||
        this.getQueryString("c") != undefined
      ) {
        this.$router.push("/signup?c=" + this.getQueryString("c"));
      } else {
        this.$router.push("/signup");
      }
    },
    heftBut(e) {
      this.$router.push(e);
    },
    but(e) {
      if (e.id == this.select) {
        console.log("不生效");
        this.popupShow = false;
      } else {
        switch (e.type) {
          case 1:
            this.$router.push(e.path);
            break;
          case 2:
            let baseurl =
              "http://chineserd.cn/h5/html/regulations/index.html?url=" +
              e.href;
            window.open(baseurl, "_blank");
            break;
          case 3:
            window.open(e.href, "_blank");
            break;
          default:
            break;
        }
      }
    },
    openHomepage() {
      window.open('https://www.chineserd.com.hk/', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.header_view {
  width: 100%;
  height: 80px;
  position: relative;

  .header {
    position: sticky;
    width: 100%;
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s;
    position: fixed;
    z-index: 99999;
    background: #ff891f;
    box-shadow: 0px 4px 20px 0px rgba(164, 79, 0, 0.15);

    .headerBox {
      max-width: 1300px;
      height: 80px;
      margin: auto;
      display: flex;
      justify-content: space-between;

      .boxLeft {
        height: 100%;

        ul {
          height: 100%;
          display: flex;

          li {
            width: 150px;
            height: 100%;
            font-size: 20px;
            font-family: PingFang SC-Semibold, PingFang SC;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
              width: 80px;
            }
          }

          .select {
            font-weight: bold;
            background: url("~@/assets/image/hodgepodge/tabBut.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .boxRight {
        height: 100%;
        display: flex;
        align-items: center;
        color: #ffffff;
        cursor: pointer;
        position: relative;
        span {
          min-width: 136px;
          height: 48px;
          // background: #d0d0d0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 15px;
          // box-shadow: 0px 4px 9px 0px rgba(244, 86, 5, 0.4);
          box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
          border-radius: 80px;
          padding: 15px;
          box-sizing: border-box;
        }
        .style_1{
          background: url("~@/assets/image/icon/but.png") no-repeat;
          background-size: 100% 100%;
        }
        .style_2{
          background: url("~@/assets/image/icon/but_2.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .upload-btns {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .upload_icon {
      position: relative;
      img {
        height: 50px;
      }
      .icon_text {
        width: 90px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-56%, -50%);
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .uploadVideo {
    cursor: pointer;
    width: 120px;
    height: 46px;
    background: url('~@/assets/image/icon/but.png') no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 15px;
    box-shadow: 0px 4px 9px 0px rgba(244, 86, 5, 0.4);
    border-radius: 80px;
    padding: 15px;
    box-sizing: border-box;
    margin-left: 10px;
  }
}
</style>
